import React, { useState, useEffect, useRef } from "react";
import { Input } from "antd";
import { CheckOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";

const EditableCell = ({
    record,
    field,
    value,
    isSpApiConnected,
    isEditing,
    onStartEdit,
    onSave,
    onCancel,
}) => {
    const [draft, setDraft] = useState("");
    const inputRef = useRef(null);
    const wasEditingRef = useRef(false);

    useEffect(() => {
        if (isEditing && !wasEditingRef.current) {
            setDraft(value ?? "");
            requestAnimationFrame(() => {
                inputRef.current?.focus();
            });
        }
        wasEditingRef.current = isEditing;
    }, [isEditing, value]);

    const isNumberField = field !== "tags";

    const handleStartEdit = (e) => {
        if (e) e.stopPropagation();
        if (!isSpApiConnected) return;
        onStartEdit(record, field);
    };

    const handleSave = (e) => {
        if (e) e.stopPropagation();
        onSave(record, field, draft);
    };

    const handleCancel = (e) => {
        if (e) e.stopPropagation();
        onCancel();
    };

    if (!isEditing) {
        return (
            <div
                className="editable-cell-container"
                onClick={handleStartEdit}
                style={{
                    cursor: isSpApiConnected ? "pointer" : "default",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "4px 8px",
                    borderRadius: "4px",
                }}
            >
                <EditOutlined className="products-edit-icon" style={{ fontSize: "12px" }} />
                <span className="products-edit-value">{value ?? "-"}</span>
            </div>
        );
    }

    return (
        <div
            style={{ display: "flex", gap: "6px", alignItems: "center" }}
            onClick={(e) => e.stopPropagation()}
        >
            <Input
                ref={inputRef}
                size="small"
                type={isNumberField ? "number" : "text"}
                value={draft}
                onChange={(e) => setDraft(e.target.value)}
                style={{ width: "120px" }}
                onPressEnter={handleSave}
            />
            <CheckOutlined
                onClick={handleSave}
                className="products-edit-confirm"
                style={{ cursor: "pointer" }}
            />
            <CloseOutlined
                onClick={handleCancel}
                className="products-edit-cancel"
                style={{ cursor: "pointer" }}
            />
        </div>
    );
};

export default EditableCell;
